(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lm-product-addons"] && !Shopify.designMode) return;
  try {
    if (!window.__lmProductAddonsCarousel) {
    window.__lmProductAddonsCarousel = true;

    window.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;

      const arrow = event.target.closest('[data-lm-addon-slide]');
      if (!arrow) return;

      const section = arrow.closest('.lm-product-addons');
      const track = section?.querySelector('.lm-product-addons__track');
      const item = track?.querySelector('.lm-product-addons__item');

      if (!track || !item) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const gap = parseFloat(getComputedStyle(track).columnGap) || 12;
      const distance = item.getBoundingClientRect().width + gap;
      const direction = Number(arrow.dataset.lmAddonSlide);
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      track.scrollBy({
        left: distance * direction,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
